'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024 from "./com.raquo.airstream.core.-Airstream-Error$.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError from "./com.raquo.airstream.core.-Airstream-Error$-Observer-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError$002dHandling$002dError from "./com.raquo.airstream.core.-Airstream-Error$-Observer-Error-Handling-Error.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$9(onTryParam$2, handleObserverErrors$4, outer) {
  this.yl = null;
  this.DG = false;
  this.DH = null;
  this.yl = onTryParam$2;
  this.DG = handleObserverErrors$4;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  this.DH = (void 0);
}
export { $c_Lcom_raquo_airstream_core_Observer$$anon$9 as $c_Lcom_raquo_airstream_core_Observer$$anon$9 };
$p = $c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$9;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$9() {
}
export { $h_Lcom_raquo_airstream_core_Observer$$anon$9 as $h_Lcom_raquo_airstream_core_Observer$$anon$9 };
$h_Lcom_raquo_airstream_core_Observer$$anon$9.prototype = $p;
$p.dP = (function() {
  return this.DH;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.lh = (function() {
  return this;
});
$p.cW = (function(nextValue) {
  this.fY(new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(nextValue));
});
$p.l6 = (function(error) {
  this.fY(new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(error));
});
$p.fY = (function(nextValue) {
  try {
    if (this.yl.de(nextValue)) {
      this.yl.j(nextValue);
    } else {
      nextValue.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err) => {
        $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(err);
      })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => (void 0))));
    }
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    if ((this.DG && nextValue.Pk())) {
      this.l6(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    } else {
      nextValue.eT(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((originalError) => {
        $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError$002dHandling$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(e$2, originalError));
      })), new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$4) => {
        $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024.$m_Lcom_raquo_airstream_core_AirstreamError$().eb(new $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError$0024$002dObserver$002dError.$c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
      })));
    }
  }
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$9 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_Observer$$anon$9, "com.raquo.airstream.core.Observer$$anon$9", ({
  gM: 1,
  aP: 1,
  M: 1,
  bH: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer$$anon$9 as $d_Lcom_raquo_airstream_core_Observer$$anon$9 };
